import Flickity from 'flickity';
import debug from 'bows';

const log = debug('resource-collection');

class ResourceCollection {
	constructor(node) {
		this.node = node;
		this.wrap = this.node.querySelector('.collection__items');
		this.items = Array.from(this.wrap.querySelectorAll('.collection__item'));

		this.flickity = new Flickity(this.wrap, {
			adaptiveHeight: false,
			autoPlay: false,
			cellAlign: 'left',
			imagesLoaded: true,
			prevNextButtons: false,
			watchCSS: true,
			wrapAround: false,
		});

		log(this);
	}
}

export default ResourceCollection;
